import api from "./api";

export const getAlcools = () => api.get("/alcools.php").then((r) => r.data);

export const getVerres = () => api.get("/verres.php").then((r) => r.data);

export const addVerre = (alcool_id, date) =>
  api.post("/verres.php", { alcool_id, date }).then((r) => r.data);

export const deleteVerre = (id) =>
  api.delete(`/verres.php?id=${id}`).then((r) => r.data);

export const getDashboard = () => api.get("/dashboard.php").then((r) => r.data);

export const getMyMonthStats = (annee, mois) =>
  api.get(`/month_stats.php?annee=${annee}&mois=${mois}`).then((r) => r.data);

export const getDayDetail = (date, amiId) => {
  const params = amiId ? `?date=${date}&ami_id=${amiId}` : `?date=${date}`;
  return api.get(`/day_detail.php${params}`).then((r) => r.data);
};